import * as React from 'react';
import * as _ from 'lodash';
import { IExpertSystemRecipient, IListItem } from '@nkr/models/index';
import { Alert, Col, ControlLabel, Form, FormControl, FormGroup } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';

interface IProps {
    recipientInfo: IExpertSystemRecipient,
    recipientList: IExpertSystemRecipient[],
    genderList: IListItem[],
    stateList: IListItem[],
    orderStatus: number,
    dobOutOfBounds: boolean,
    donorAlias: string,
    onDataChange: (data: IExpertSystemRecipient) => void
}

class SelectCreateRecipient extends React.Component<IProps, {}> {
    handleAliasChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.alias = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handleFnameChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.firstName = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handleLnameChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.lastName = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handleEmailChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.email = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handleAddr1Change = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.address1 = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handleAddr2Change = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.address2 = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handleCityChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.city = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handleStateChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.state = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handlePostalCodeChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.postalCode = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handleDobChange = (e: React.FormEvent<any>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.birthDate = e.currentTarget.value;

        this.props.onDataChange(data);
    }

    handleGenderChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.gender = e.currentTarget.value;

        this.props.onDataChange(data);
    };

    handlePhoneChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.props.recipientInfo);
        data.phone = e.currentTarget.value;

        this.props.onDataChange(data);
    };


    handleRecipientChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let recipientId = parseInt(e.currentTarget.value);

        let recipientInfo = {
            recipientId: 0,
            centerId: 0,
            alias: '',
            firstName: '',
            lastName: '',
            email: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            postalCode: '',
            birthDate: '',
            gender: '',
            phone: '',
            hasTyping: false
        }

        if (recipientId > 0) {
            recipientInfo = _.cloneDeep(this.props.recipientList.find((x) => x.recipientId == recipientId));
        }

        this.props.onDataChange(recipientInfo);
    };

    getSortedRecipientList = () => {
        let aliasOnly = _.sortBy(this.props.recipientList.filter(x => x.lastName == ''), x => x.alias);
        let full = _.sortBy(this.props.recipientList.filter(x => x.lastName != ''), x => x.lastName);

        return [...full, ...aliasOnly];
    }

    render = () => {
        const recipientList = this.getSortedRecipientList();
        const { recipientId, alias, firstName, lastName, email, address1, address2, city, state, postalCode, birthDate, gender, phone } = this.props.recipientInfo;
        const { dobOutOfBounds, donorAlias } = this.props;

        return (
            <Form horizontal>
                <FormGroup>
                    <Col xs={12}>
                        {this.props.orderStatus == 2 && (
                            <h4 style={{ margin: 0 }}>Donor(<b>{donorAlias}</b>) HLA is on file. Please select a recipient or create a new one.</h4>
                        )}

                        {this.props.orderStatus == 1 && (
                            <h4 style={{ margin: 0 }}>Donor(<b>{donorAlias}</b>) HLA is not yet on file. You may ship the cheek swab kit early. Please select a recipient or create a new one.</h4>
                        )}
                    </Col>
                </FormGroup>

                <Alert bsStyle='warning'>The following information is required...</Alert>

                {dobOutOfBounds && (
                    <Alert bsStyle='danger'>Date of Birth must valid and in the past.</Alert>
                )}

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Recipient Options:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            componentClass='select'
                            bsSize='small'
                            value={recipientId}
                            onChange={this.handleRecipientChange}
                        >
                            <option value={0}>- Create a new recipient -</option>
                            {recipientList.map((mp, index) =>
                                <option key={'recp-' + index} value={mp.recipientId}>
                                    {mp.firstName != '' && mp.lastName != '' ? `${mp.lastName}, ${mp.firstName} (${mp.alias})` : mp.alias}
                                </option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Alias:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            value={alias}
                            onChange={this.handleAliasChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>First Name:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            value={firstName}
                            onChange={this.handleFnameChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Last Name:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            value={lastName}
                            onChange={this.handleLnameChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Email:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            value={email}
                            onChange={this.handleEmailChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Address 1:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            value={address1}
                            onChange={this.handleAddr1Change}
                        />
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Address 2:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            value={address2}
                            onChange={this.handleAddr2Change}
                        />
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>City:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            value={city}
                            onChange={this.handleCityChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>State:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            componentClass='select'
                            value={state}
                            onChange={this.handleStateChange}
                        >
                            <option value={0}>- select -</option>
                            {this.props.stateList.map((state, index) =>
                                <option key={`state-${index}`} value={state.abbreviation}>{state.description}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Postal Code:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            value={postalCode}
                            onChange={this.handlePostalCodeChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Phone Number:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            value={phone}
                            onChange={this.handlePhoneChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup validationState={dobOutOfBounds ? 'error' : null}>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Date of Birth:</Col>
                    <Col xs={12} lg={6}>
                        <MaskedInput
                            className='form-control'
                            mask='11/11/1111'
                            name='birthDate'
                            value={birthDate}
                            onChange={this.handleDobChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={4} componentClass={ControlLabel}>Gender:</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            componentClass='select'
                            value={gender}
                            onChange={this.handleGenderChange}
                        >
                            <option value={''}>- select -</option>
                            {this.props.genderList.map((gender, index) =>
                                <option key={`gender-${index}`} value={gender.description.substr(0, 1)}>{gender.description}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>
            </Form>
        );
    };
}

export default SelectCreateRecipient;
